import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { EvtHeader } from "components/header";
import { CustomList } from "components";
import { Badge } from "ui/components/badge";
import { EmployeeCell } from "components/cell/employee/cell";
import { NameCell } from "@/components/cells/name";
import { RelativeDateCell } from "@/components/date/cell";
import { repoQuery } from "./layout";
import RepoBranchStats from "./stats";

// Global Integrations → GitHub → repository dashboard. Separate from the
// project-level GitHub screen (modules/work/projects/integrations/github).
const columns = [
  {
    id: "name",
    header: "Branch",
    accessorKey: "name",
    cell: ({ row }) => (
      <div className="flex items-center gap-2">
        <span className="font-medium">{row.original.name}</span>
        {row.original.is_default && <Badge variant="outline">Default</Badge>}
        {row.original.is_protected && <Badge variant="outline">Protected</Badge>}
      </div>
    ),
  },
  {
    id: "last_commit.message",
    header: "Last commit",
    accessorFn: (row) => row?.last_commit?.message || "-",
    cell: NameCell,
    size: 520, // widest column
  },
  {
    id: "last_commit.author.employee",
    header: "Author",
    accessorFn: (row) => row?.last_commit?.author?.employee,
    cell: EmployeeCell,
    size: 80, // avatar only
  },
  {
    id: "last_commit.author.github_username",
    header: "GitHub Username",
    accessorFn: (row) => row?.last_commit?.author?.github_username || "-",
    cell: NameCell,
  },
  {
    id: "last_commit.date",
    header: "Updated",
    accessorFn: (row) => row?.last_commit?.date,
    cell: RelativeDateCell,
  },
];

// Branches tab of the repository sidebar. Repo name / back / GitHub link are in the sidebar header.
export default function GithubRepoDashboard() {
  const { repo_id } = useParams();
  const { data: repo } = useQuery(repoQuery(repo_id));

  return (
    <div className="flex-1">
      <div className="py-2">
        <EvtHeader title="Branches" />
      </div>
      <section className="mt-1.5">
        <RepoBranchStats repositoryUrl={repo?.repository_url} />
      </section>
      {repo?.repository_url && (
        <div className="mt-6">
          <CustomList
            title="Branches"
            storageKey={`integrations-github-branches-${repo_id}`}
            endPoint="github/repository/branches"
            filters={{ repository_url: repo.repository_url }}
            columns={columns}
            perPage={10}
            sortBy=""
            showSearch={false}
            // Each branch row opens its activity page (commits + reset HEAD).
            href={(item) =>
              `/integrations/github/repositories/${repo_id}/branches/${encodeURIComponent(item?.name)}`
            }
          />
        </div>
      )}
    </div>
  );
}